import React, {useEffect, useState} from 'react';

import {Paper, Typography} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../styles/styles";
import {useLazyQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import SsnListHashArea from "../components/Ssn/SsnListHashArea";
import getEnvironment from "../utils/getEnvironment";

const SsnHash = () => {
    const classes = useStyles();
    const env = getEnvironment();
    const [finalValue, setFinalValue] = useState('');

    /**
     * Create Single Value SignatureBlock Graphql
     */
    const [getSsnHashList, {loading, error, data}] = useLazyQuery(gql`
        query HashSsnList($input: SsnListToHashInput!) {
            hashSsnList(input: $input) {
                errorReason
                ssnHashList
                success
          }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    useEffect(() => {
        if (data) {
            setFinalValue(data.hashSsnList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    function getOutput(finalData) {
        if (finalData) {
            if (finalData.success) {
                const values = finalValue.ssnHashList.map((result, index) => {
                    return (<Alert severity={"success"}>
                        {result}
                    </Alert>);
                })

                return (<><Alert severity={"success"}>
                        Successfully hashed the submitted SSNs
                    </Alert>
                        {values}
                    </>
                );
            } else {
                return <Alert severity={"error"}>
                    {finalValue.errorReason}
                </Alert>
            }
        }

        return null
    }

    /**
     * Main Return for Component
     */
    return (
        <>
            <Typography variant="h2">
                SSN Hashing
            </Typography>
            {env === 'prod' ?
                <>
                    {(error) ? (<Paper className={classes.paper}>
                        <Alert severity="error">There is an error!</Alert>
                        <pre>{JSON.stringify(error, null, 2)}</pre>
                    </Paper>) : null}

                    <SsnListHashArea
                        hashSsnQuery={getSsnHashList}
                        hashSsnQueryLoading={loading}
                    />

                    {getOutput(finalValue)}
                </>
                :
                <Typography variant="h3">
                    This page is only available via the Prod admin
                </Typography>
                }
        </>
    )
};

export default SsnHash;
